const status = [
  {
    path: '/vacation/status/current',
    component: () => import('@/page/vacation/status/Current.vue'),
    meta: {
      name: '사용 휴가',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/vacation/status/allow',
    component: () => import('@/page/vacation/status/Allow.vue'),
    meta: {
      name: '지급 휴가',
      isActive: false,
      isBread: false,
    },
  },
];

export default status;
